import React, { HTMLAttributes } from 'react'

export const Logo = (props: HTMLAttributes<HTMLImageElement>) => {
  return (
    <img
      className="max-w-[12rem] md:max-w-[10rem] lg:max-w-[16rem]"
      src={'/logo.svg'}
      alt="TOPTAX"
      width={256}
      height={58}
      {...props}
    />
  )
}
